// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../views/RedirectoLogin";
import AccountProfile from "../containers/profiles/AccountProfile";

class Profile extends Component<*> {
  render(): * {
    return (
      <UserAuth principal="user" unAuthChildren={<RedirectoLogin />}>
        <div className="app-main">
          <AccountProfile />
        </div>
      </UserAuth>
    );
  }
}

export default Profile;
